import React from 'react'
import { Modal } from 'components/UI/Modal'

export type EmailTab = 'received' | 'sent'
export type ModalView = 'list' | 'email'

interface EmailsModalHeaderProps {
  companyName?: string
  view: ModalView
  activeTab: EmailTab
  emailSubject?: string
  onBreadcrumbClick?: () => void
  /** When true, shows a simple header without breadcrumb navigation */
  emailOnlyMode?: boolean
}

export function EmailsModalHeader({
  companyName,
  view,
  activeTab,
  emailSubject,
  onBreadcrumbClick,
  emailOnlyMode,
}: EmailsModalHeaderProps) {
  const breadcrumbLabel = activeTab === 'received' ? 'Received' : 'Sent'

  // Email-only mode: simple header with just the subject
  if (emailOnlyMode) {
    return (
      <Modal.Header className="px-[32px] py-[20px] border-0">
        <div className="flex flex-col gap-1 w-full">
          {companyName && (
            <div className="text-[11px] font-light uppercase tracking-[0.03em] leading-[28px] align-middle text-[#6E6E6E]">
              {companyName}
            </div>
          )}
          <Modal.Title className="text-2xl font-normal leading-[1.2] tracking-[0em] align-middle text-[#101828] m-0">
            {emailSubject || 'Email'}
          </Modal.Title>
        </div>
      </Modal.Header>
    )
  }

  if (view === 'list') {
    // List view: Company Name / Emails
    return (
      <Modal.Header className="px-[32px] py-[20px] border-0">
        <div className="flex flex-col gap-1 w-full">
          <div className="text-[11px] font-light uppercase tracking-[0.03em] leading-[28px] align-middle text-[#6E6E6E]">
            {companyName}
          </div>
          <Modal.Title className="text-2xl font-normal leading-[1.2] tracking-[0em] align-middle text-[#101828] m-0">
            Emails
          </Modal.Title>
        </div>
      </Modal.Header>
    )
  }

  // Email view: Company Name | Received (clickable) / Email Subject
  return (
    <Modal.Header className="px-[32px] py-[20px] border-0">
      <div className="flex flex-col gap-1 w-full">
        {/* Company name + breadcrumb row */}
        <div className="flex flex-row items-center gap-1 text-[11px] font-light uppercase tracking-[0.03em] leading-[28px] align-middle text-[#6E6E6E]">
          <span>{companyName}</span>
          <span className="text-[#E2E2E2]">|</span>
          <button
            type="button"
            onClick={onBreadcrumbClick}
            className="text-[#2C6B4E] underline hover:text-[#1e4d38] transition-colors"
          >
            {breadcrumbLabel}
          </button>
        </div>
        {/* Email subject as title */}
        <Modal.Title className="text-2xl font-normal leading-[1.2] tracking-[0em] align-middle text-[#101828] m-0">
          {emailSubject || 'Email'}
        </Modal.Title>
      </div>
    </Modal.Header>
  )
}
